export const REFRESH_INTERVAL_MS = 30000;

export const TOASTER_OPTIONS = {
  duration: 4000,
  style: {
    background: '#1f2937',
    color: '#fff',
  },
};

export const STATUS_STYLES = {
  // Alert Panel & General Status
  critical: {
    base: 'bg-red-50 border-red-200 text-red-800',
    icon: 'text-red-500',
  },
  warning: {
    base: 'bg-amber-50 border-amber-200 text-amber-800',
    icon: 'text-amber-500',
  },
  info: {
    base: 'bg-blue-50 border-blue-200 text-blue-800',
    icon: 'text-blue-500',
  },
  healthy: {
    base: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    icon: 'text-emerald-500',
  },
  low: {
    base: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: 'text-amber-500',
  },
  default: {
    base: 'bg-gray-50 border-gray-200 text-gray-800',
    icon: 'text-gray-500',
  },

  // Dispatch & Sales Statuses
  high: 'bg-red-100 text-red-800 border-red-200',
  medium: 'bg-amber-100 text-amber-800 border-amber-200',
  // low priority uses 'healthy' style

  approved: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  sent: 'bg-blue-100 text-blue-800 border-blue-200',
  draft: 'bg-gray-100 text-gray-800 border-gray-200',
  premium: 'bg-purple-100 text-purple-800 border-purple-200',
  active: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  at_risk: 'bg-red-100 text-red-800 border-red-200',

  // Financial Statuses
  overdue: 'bg-amber-100 text-amber-800 border-amber-200',
  current: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  pending_generation: 'bg-blue-100 text-blue-800 border-blue-200',
  ready_to_send: 'bg-purple-100 text-purple-800 border-purple-200',

  // Settings Statuses
  connected: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  disconnected: 'bg-red-100 text-red-800 border-red-200',
};

export const METRIC_COLORS = {
  emerald: { bg: 'bg-emerald-50', icon: 'bg-emerald-500' },
  blue:    { bg: 'bg-blue-50',    icon: 'bg-blue-500' },
  amber:   { bg: 'bg-amber-50',   icon: 'bg-amber-500' },
  purple:  { bg: 'bg-purple-50',  icon: 'bg-purple-500' },
};

export const TREND_COLORS = {
  up: 'text-emerald-600',
  down: 'text-red-600',
};

export const QUICK_ACTION_COLORS = {
  blue: 'bg-blue-50 hover:bg-blue-100 text-blue-700',
  emerald: 'bg-emerald-50 hover:bg-emerald-100 text-emerald-700',
  purple: 'bg-purple-50 hover:bg-purple-100 text-purple-700',
  amber: 'bg-amber-50 hover:bg-amber-100 text-amber-700',
  red: 'bg-red-50 hover:bg-red-100 text-red-700',
  indigo: 'bg-indigo-50 hover:bg-indigo-100 text-indigo-700',
};
